export const DOMAIN_KEY = process.env.REACT_APP_DOMAIN
export const CLIENT_KEY = process.env.REACT_APP_CLIENTID
